export default "__VITE_ASSET__41662d12__"